import {useEffect, useState} from 'react'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {BASE_URL} from '../../config'
import {IRouteConfig} from '../_model'
import {useQuery} from 'react-query'
import axios from 'axios'
import {IPagination} from '../../../utils/core/_model'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import routesListColumn from '../helper/routesListColumn'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import {useRouteConfig} from '../ConfigRoutesProvider'
import toast from 'react-hot-toast'
import {useNavigate} from 'react-router-dom'

const ROUTE_CONFIG_LIST = `${BASE_URL}/api/protect/routeList`
const ROUTE_CONFIG_BY_ID = `${BASE_URL}/api/protect/getRoutConfById`

const RoutesTable = () => {
  const {searchTerm, setDeleteRoute, setUpdateRoute, resetSelected} = useRouteConfig()
  const {
    pagination: {totalElement, page, size},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)
  const navigate = useNavigate()

  const [filteredRoutes, setFilteredRoutes] = useState<IRouteConfig[]>([])

  const {
    isLoading,
    data: routesConfigList,
    error,
  } = useQuery({
    queryKey: ['routeConfigList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(ROUTE_CONFIG_LIST, {
        params: {
          page,
          size,
        },
      })

      const result = await response.data
      const pagination = await result.pagenationResponse

      // console.log(result)
      return {
        list: result.content,
        pagination,
      }
    },
  })

  const handleSelectRoute = async (selectType: string, id: number) => {
    toast.loading('Processing..')

    const response = await axios.get(`${ROUTE_CONFIG_BY_ID}/${id}`)

    if (response.status === 200) {
      const data = await response.data

      switch (selectType) {
        case 'edit':
          // setUpdateRoute(data)
          // navigate('/routes/configure')
          break
        case 'delete':
          setDeleteRoute(data)
          break

        default:
          break
      }
      console.log(data)
    }

    toast.dismiss()
  }

  useEffect(() => {
    if (routesConfigList && routesConfigList.list) {
      const keys: (keyof IRouteConfig)[] = ['url', 'name']

      const filtered = searchItems(routesConfigList.list, searchTerm, keys)

      setFilteredRoutes(filtered)
      updatePagination(routesConfigList.pagination)
    } else {
      setFilteredRoutes([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, routesConfigList])

  return (
    <ListViewProvider isLoading={isLoading} data={filteredRoutes}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />

      <TableContent
        isLoading={isLoading}
        tableData={filteredRoutes}
        tableColumn={routesListColumn(handleSelectRoute)}
      >
        {isLoading ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <TablePagination
            totalElement={totalElement}
            isLoading={isLoading}
            itemsPerPage={size}
            currentPage={page}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContent>
    </ListViewProvider>
  )
}

export default RoutesTable
